// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module--content--2_XMI","label":"index-module--label--21sR4","ukIcon":"index-module--ukIcon--SfXKI","divide":"index-module--divide--3Vzb2"};